import { AuthServiceError } from './AuthServiceError'

export class NotAuthorizedError extends AuthServiceError {
  constructor() {
    super('User is not authorized.', 'NOT_AUTHORIZED')
    this.name = 'NotAuthorizedError'
  }
}
